import { render, staticRenderFns } from "./Xmas.vue?vue&type=template&id=5bbf5678&scoped=true&"
import script from "./Xmas.vue?vue&type=script&lang=js&"
export * from "./Xmas.vue?vue&type=script&lang=js&"
import style0 from "./Xmas.vue?vue&type=style&index=0&id=5bbf5678&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf5678",
  null
  
)

export default component.exports